import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import { useSnackbar } from "notistack";
import { purchaseSummary, purchaseLines, purchaseDate, purchaseTitles } from "./OrdersPDFExport.jsx";

export default function ExportExcelJSButton({ currentRows = [] }) {
  const { enqueueSnackbar } = useSnackbar();
  const exportToExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(purchaseTitles.receive + " Records");
      worksheet.columns = [
        { header: "Record ID", key: "id", width: 30 }, { header: "Purchase Order", key: "orderId", width: 30 },
        { header: "Supplier", key: "supplier", width: 25 }, { header: "Destination", key: "warehouse", width: 25 },
        { header: "Status", key: "status", width: 20 }, { header: "Date", key: "date", width: 25 },
        { header: "Lines", key: "count", width: 12 }, { header: "Units", key: "quantity", width: 12 },
        { header: "Currency", key: "currency", width: 12 }, { header: "Amount", key: "amount", width: 18 },
        { header: "Paid", key: "paid", width: 18 }, { header: "Due", key: "due", width: 18 },
        { header: "Payment Status", key: "paymentStatus", width: 20 },
      ];
      const items = workbook.addWorksheet("Item Lines");
      items.columns = [
        { header: "Record ID", key: "id", width: 30 }, { header: "SKU", key: "sku", width: 20 }, { header: "Item", key: "name", width: 30 },
        { header: "Quantity", key: "quantity", width: 15 }, { header: "Unit Cost", key: "price", width: 15 }, { header: "Line Value", key: "total", width: 18 },
        { header: "Currency", key: "currency", width: 12 }, { header: "Batch", key: "batch", width: 20 }, { header: "Expiry", key: "expiryDate", width: 25 },
        { header: "Rejected", key: "rejectedQty", width: 15 }, { header: "Reason", key: "reason", width: 30 },
      ];
      currentRows.forEach((record) => {
        const summary = purchaseSummary(record, "receive");
        worksheet.addRow({ ...summary, date: purchaseDate(summary.date), paid: record.payment?.paidAmount, due: record.payment?.dueAmount, paymentStatus: record.payment?.paymentStatus });
        purchaseLines(record, "receive").forEach((line) => items.addRow({ ...line, id: summary.id, currency: summary.currency, expiryDate: purchaseDate(line.expiryDate) }));
      });
      [worksheet, items].forEach((sheet) => sheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF007BFF" } };
        cell.alignment = { vertical: "middle", horizontal: "center" };
      }));
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), `${purchaseTitles.receive} Records.xlsx`);
    } catch (error) { enqueueSnackbar("Excel export failed. Please try again.", { variant: "error" }); }
  };
  return <button className="recieves_export_btn fx-ac spacem" onClick={exportToExcel} style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}><MultipleStopIcon fontSize="large" style={{ transform: "rotate(90deg)" }} /><span>Export Excel</span></button>;
}
